import React from 'react';
import PropTypes from 'prop-types';

import withStyles from 'material-ui-next/styles/withStyles';

import { Tab } from 'material-ui-next/Tabs';

const styles = theme => ({
  // Name of the styleSheet
  root: {
    height: 48,
    minWidth: 50,
    fontWeight: '400',
    [theme.breakpoints.up("md")]: {
      minWidth: 'inherit',
    },
    color: 'rgba(0,0,0,.77)',
  },
  rootInheritSelected: {
    fontWeight: '500',
    opacity: 1,
    color: 'rgba(0,0,0,.87)',
  },
  labelContainer: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  label: {
    fontSize: theme.typography.pxToRem(theme.typography.fontSize),
    textTransform: 'none',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(theme.typography.fontSize),
    },
  },
})

const AlternateTab = ({classes, ...props}) => {
  return <Tab classes={classes} {...props}/>
}

AlternateTab.propTypes = Object.assign({}, Tab.propTypes, {
  classes: PropTypes.object.isRequired
});

export default withStyles(styles)(AlternateTab);



// WEBPACK FOOTER //
// ./src/components/ApplicationBar/CustomTab.jsx